import url from './url';



export default url(({ featureSource, featureId = ':featureId' }) => `/${featureSource}/${featureId}/edit`);
